import { render, staticRenderFns } from "./cooperation_cert_list.vue?vue&type=template&id=03c4958e&scoped=true&"
import script from "./cooperation_cert_list.vue?vue&type=script&lang=js&"
export * from "./cooperation_cert_list.vue?vue&type=script&lang=js&"
import style0 from "./cooperation_cert_list.vue?vue&type=style&index=0&id=03c4958e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c4958e",
  null
  
)

export default component.exports